import { handleWidgetUpdate } from '@juvare/common-form-ui/WidgetForm/Utils';
import React from 'react';
import { BadgeTemplateTwoSidePreview } from '../../badge-preview/components/BadgeTemplateTwoSidePreview';
const type = 'badges.templatePreview';
const BadgeTemplatePreviewWidget = (props) => {
    const classifierData = props.rootData;
    const { badgeTemplateFront, badgeTemplateBack, defaultFormSettings, defaultSampleAccountData } = classifierData;
    return (React.createElement(BadgeTemplateTwoSidePreview, { badgeTemplateClassifier: classifierData, badgeTemplateFront: badgeTemplateFront, badgeTemplateBack: badgeTemplateBack, formSettings: defaultFormSettings, account: defaultSampleAccountData }));
};
export const badgeTemplatePreviewWidget = {
    type,
    createWidget: () => {
        return {
            type,
        };
    },
    update: (props) => {
        props.update();
        return handleWidgetUpdate(props);
    },
    component: BadgeTemplatePreviewWidget,
};
